module.exports = __webpack_public_path__ + "static/media/syd_second_selected.21d14cec.svg";